import styled from "styled-components";
import { useQuery } from "@tanstack/react-query";

import { SrOnly } from "@/components/Layout/Parts";
import { ResponsiveTable, Table, TableContent, Th } from "@/components/Table";
import ExtractorRecentResultsRow from "./ExtractorRecentResultsRow";
import { SectionHeading } from "@/components/Layout/Parts";
import { api } from "@/utils/api";
import { VideoFramesExportResource } from "@/types/resources";

const StyledTable = styled(Table)`
  th,
  td {
    padding: 16px 12px;
    font-size: 11px;
    &:nth-child(1) {
      padding-left: 24px;
      width: 26%;
    }
    &:nth-child(2) {
      width: 14%;
    }
    &:nth-child(3) {
      width: 14%;
    }
    &:nth-child(4) {
      width: 14%;
    }
    &:nth-child(5) {
      width: 8%;
    }
    &:nth-child(6) {
    }
    &:last-child {
      padding-right: 16px;
      padding-left: 16px;
    }
  }
`;

const ExtractorRecentResults = () => {
  const { data, isLoading, isError } = useQuery(
    ["video_frames_exports"],
    () =>
      api.get<never, VideoFramesExportResource[]>("/v1/video-frames-exports"),
    {
      staleTime: 15 * 1000,
      refetchInterval: 15 * 1000,
    }
  );

  return (
    <>
      <SectionHeading>Recent results</SectionHeading>
      <ResponsiveTable>
        <StyledTable $fixed>
          <thead>
            <tr>
              <Th>Recent Extracts</Th>
              <Th>Date</Th>
              <Th>Status</Th>
              <Th>Type</Th>
              <Th>FPS</Th>
              <Th>Extracted Files Quantity</Th>
              <Th $actionsCol>
                <SrOnly>Actions</SrOnly>
              </Th>
            </tr>
          </thead>
          <tbody>
            <TableContent
              isLoading={isLoading}
              colSpan={7}
              isError={isError}
              hasData={!!data?.length}
              emptyTableText="No results"
            >
              {data?.map((framesExport) => (
                <ExtractorRecentResultsRow
                  framesExport={framesExport}
                  key={framesExport.id}
                />
              ))}
            </TableContent>
          </tbody>
        </StyledTable>
      </ResponsiveTable>
    </>
  );
};

export default ExtractorRecentResults;
